import * as React from 'react';
import { imageMap } from '.images';

const Image = ({ image, ...restProps }: any) => {
  const [imagePath, setImagePath] = React.useState('');
  React.useEffect(() => {
    if (image) {
      if (typeof image === 'string') {
        setImagePath(image);
      } else if (image.type) {
        setImagePath(URL.createObjectURL(image));
      } else {
        setImagePath('');
      }
    } else {
      setImagePath('');
    }
  }, [image]);
  return <img src={imagePath} {...restProps} />;
};

export default Image;
